import { render, staticRenderFns } from "./EventBattles.vue?vue&type=template&id=1033c6c2&scoped=true"
import script from "./EventBattles.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventBattles.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventBattles.vue?vue&type=style&index=0&id=1033c6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1033c6c2",
  null
  
)

export default component.exports